





















































import { Component, Vue, Prop } from 'vue-property-decorator';
import QuickReplyIcon from 'vue-material-design-icons/PlaylistCheck.vue';
import TriggerIcon from 'vue-material-design-icons/Flash.vue';
import QuestionIcon from 'vue-material-design-icons/ForumOutline.vue';
import LinkedPathsIcon from 'vue-material-design-icons/CallSplit.vue';
import PauseBotIcon from 'vue-material-design-icons/Pause.vue';
import TextIcon from 'vue-material-design-icons/FormatTitle.vue';
import DragIcon from '@/shared/components/DragIcon.vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import DecisionIcon from 'vue-material-design-icons/SourceBranch.vue';
import GoToIcon from '@/shared/icons/GoToIcon.vue';

@Component({
	components: {
		QuickReplyIcon,
		TriggerIcon,
		QuestionIcon,
		LinkedPathsIcon,
		PauseBotIcon,
		TextIcon,
		DragIcon,
		FlowIcon,
		DecisionIcon,
		GoToIcon
	}
})
export default class IslandBadge extends Vue {
	@Prop() public type: string;
	@Prop({default: true}) public draggable: boolean;
	public showDragIcon: boolean = false;
}
